angular.module('picmonicng').factory('SchoolSourcingModal', [
  '$modal',
  function ($modal) {
    return {
      show: function () {
        return $modal.open({
          backdrop: 'static',
          keyboard: false,
          templateUrl: '/templates/modals/school-sourcing-modal.html',
          controller: [
            '$scope',
            '$q',
            'toaster',
            'UserService',
            'User',
            'Schools',
            '$timeout',
            'SalesforceChatService',
            function ($scope, $q, toaster, UserService, User, Schools, $timeout, SalesforceChatService) {
              $scope.loading = true;
              $scope.saving = false;
              $scope.error = '';
              $scope.schools = [];
              $scope.selectedSchool = {};
              $scope.selectedIndex = -1;
              $scope.otherSchool = {};
              $scope.UserService = UserService;

              $scope.machine = User.queryv3({
                resource: 'school_recommendations',
              });
              $scope.standard = Schools.search({
                query: '',
                market_id: UserService.user.lead,
              });

              if (typeof atlasEvent !== 'undefined') {
                atlasEvent('click', 'school_sourcing_modal_seen');
              }

              $q.all([$scope.standard.$promise, $scope.machine.$promise])
                .then(function () {
                  $scope.schools = $scope.schools.concat(
                    $scope.machine,
                    $scope.standard[0],
                    $scope.standard[1],
                    $scope.standard[2]
                  );
                })
                .finally(function () {
                  $scope.loading = false;
                });

              $scope.formIsValid = function () {
                return (
                  ($scope.selectedSchool.id && $scope.selectedSchool.id !== 'other') ||
                  ($scope.selectedSchool.id && $scope.selectedSchool.id === 'other' && $scope.otherSchool.id)
                );
              };

              $scope.addSchool = function () {
                $scope.$close();
                $timeout(function () {
                  window.location.href =
                    'mailto:feedback@picmonic.com' +
                    '?subject=' +
                    'Please add my ' +
                    UserService.user.market.name +
                    ' school to your database!' +
                    '&body=' +
                    'Please add my school to Picmonic’s database. My school is ' +
                    UserService.user.market.name +
                    ' located in _______________ and I am in a _______________ type of program.';
                }, 1500);
              };

              $scope.save = function () {
                if (!$scope.formIsValid() || $scope.saving) {
                  return;
                }

                $scope.saving = true;
                $scope.error = '';

                var schoolId =
                  $scope.selectedSchool.id && $scope.selectedSchool.id !== 'other'
                    ? $scope.selectedSchool.id
                    : $scope.otherSchool.id;

                if (typeof atlasEvent !== 'undefined') {
                  atlasEvent(
                    'click',
                    'school_sourcing_modal_selected ' +
                      $scope.selectedIndex +
                      ' ' +
                      $scope.schools.length +
                      ' ' +
                      schoolId
                  );
                }

                UserService.user.school = { id: schoolId };

                UserService.user.$update(
                  function () {
                    $scope.$close();
                    $scope.saving = false;
                    toaster.success('Your school has been updated.');
                  },
                  function (error) {
                    $scope.error = error.data.message;
                    $scope.saving = false;
                  }
                );
              };
            },
          ],
        });
      },
    };
  },
]);
